import Swiper, { Scrollbar, Navigation } from 'swiper';
import 'swiper/css';
import 'swiper/css/scrollbar';

export const ComparisonChart = ( el ) => {
	const ui = {
		el,
		swiper: el.querySelector('.comparison-chart__swiper-container'),
		swiperScrollbar: el.querySelector('.swiper-scrollbar'),
	};

	Swiper.use( [ Scrollbar, Navigation ] );

    const breakpoint = window.matchMedia( '(min-width: 1040px)' );
    let swiperSlides;

    const breakpointChecker = function() {
        if ( breakpoint.matches === true ) {
            if ( swiperSlides !== undefined ) swiperSlides.destroy( true, true );
            return;
        } else if ( breakpoint.matches === false ) {
            return enableSwiper();
        }
    };

    const enableSwiper = function() {
        swiperSlides = new Swiper (ui.swiper, {
            centeredSlides: false,
            loop: false,
            slidesPerView: 'auto',
            speed: 300,
            scrollbar: {
                el: ui.swiperScrollbar,
                draggable: true,
            },
        });
    };

    breakpoint.addEventListener( 'change', () => {
        breakpointChecker();
    });

    breakpointChecker();
};

export default ComparisonChart;
